module.exports = __webpack_public_path__ + "img/lets-jetty-mark.4ed68fa3.jpeg";